import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  list: {},
  scrollIndex: 0,
};

export const category = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setList: (state, action) => ({
      ...state,
      list: action.payload
    }),
    setScrollIndex: (state, action) => ({
      ...state,
      scrollIndex: action.payload
    }),
  },
  effects: () => ({}),
});

export const { setList, setScrollIndex } = category.actions;
export const selectList = (state) => state.category.list;

export default category.reducer;